<h1 mat-dialog-title>Confirm Delete</h1>
<div mat-dialog-content>
  <p>Are you sure you want to delete this item?</p>
</div>
<div mat-dialog-actions class="d-flex justify-content-end p-2">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button color="warn" (click)="onConfirm()">Delete</button>
</div>
